module.exports = __webpack_public_path__ + "img/26.312ea2da.jpg";